(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mggp-player"] = factory();
	else
		root["mggp-player"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-player.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-player.js":
/*!****************************!*\
  !*** ./src/mggp-player.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//CDN TEST 1

var MggpPlayer = module.exports = function () {

  var player = {};

  var _vendors = [];
  var _plugins = [];
  var _observer = new Observer();
  var _contentVendor = null;
  var _updatePlayerTimer = null;
  var _data = {};
  var _stoppingPromise = null;
  var _isLoadInProgress = false;
  var _methods = ['play', 'pause', 'togglePlayPause', 'seekTo', 'mute', 'unMute', 'setVolume', 'setQuality', 'setAudioTrack', 'setSubtitles'];

  player.on = player.addEventListener = _observer.on;
  player.off = player.removeEventListener = _observer.off;
  player.emit = player.dispatchEvent = _observer.emit;

  player.init = function (pID, pContainer, pConfig, pModules) {
    player.id = pID;
    player.parentContainer = pContainer;
    player.config = pConfig;

    player.use(pModules);

    if (player.config['singleVideoInstance'] == true) {
      var videoInstances = [];
      videoInstances.push(createVideoInstances('ad:vendor:video', document.getElementById('mggp-ad-container')));
      videoInstances.push(createVideoInstances('player:video'));
      player.registerProperty('videoInstances', null, true);
      player.set('videoInstances', videoInstances);
    }

    player.emit('player:ready');
  };

  player.inspectPlugins = function () {
    for (var i = 0; i < _plugins.length; i++) {
      var plugin = _plugins[i];
      try {
        var info = (plugin.name || plugin.constructor.name) + ':';
        if (plugin.hasOwnProperty('version')) {
          info += ' v.' + plugin.version;
        }
        if (plugin.hasOwnProperty('build')) {
          info += ' (build: ' + plugin.build + ')';
        }
        console.log(info);
      } catch (e) {
        // we would live with it
      }
    }
  };

  player.use = function (modules) {
    modules.forEach(function (module) {
      if (module.hasOwnProperty('default')) module = module['default'];
      if (module.hasOwnProperty('mimeTypes')) {
        _vendors.push(module);
      } else {
        _plugins.push(new module(player, player.config));
      }
    });
  };

  _methods.forEach(function (methodName) {
    player[methodName] = function () {
      if (_contentVendor && _contentVendor[methodName]) {
        return _contentVendor[methodName].apply(_contentVendor, arguments);
      }
    };
  });

  /**
  * 
  * @param {string} pExtension type of the video, e.g. m3u8, mpd, mp4
  * @param {Object} pOptions additional options and info about video
  * @param {boolean} pOptions.isDrm flag that indicates if this is a drm stream
  */
  player.canPlay = function (pExtension, pOptions) {
    return player.getVendor(pExtension, pOptions) !== null;
  };

  player.load = function (pSrc, pVideoInfo, pOptions) {
    if (window.Promise && _stoppingPromise instanceof window.Promise) {
      _stoppingPromise.finally(function () {
        _load();
        _isLoadInProgress = false;
      });
      _stoppingPromise = null;
    } else {
      _load();
      _isLoadInProgress = false;
    }

    function _load() {
      _isLoadInProgress = true;

      var vendorOptions = pOptions || {};

      if (pVideoInfo) {
        var isDrm = Boolean(pVideoInfo.drm_type);
        player.config.drm = isDrm;
        vendorOptions.isDrm = isDrm;
      }

      player.utils.log("MggpPlayer.load():");
      player.set('vendorOptions', vendorOptions);
      player.set('src', pSrc || null);
      player.set('videoInfo', pVideoInfo || null);

      if (!_updatePlayerTimer) {
        player.utils.log('MggpPlayer.load:Create timer');
        _updatePlayerTimer = setInterval(onGlobalUpdate, player.config && player.config.hasOwnProperty('timeInterval') ? player.config['timeInterval'] : 1000 / 3);
      }

      for (var i = 0, l = _plugins.length; i < l; ++i) {
        var pluginLoadResult;
        if (typeof _plugins[i].load === 'function') {
          pluginLoadResult = _plugins[i].load(pSrc, pVideoInfo, vendorOptions);
          if (pluginLoadResult === false) {
            return;
          }
        }
      }
      // _plugins.forEach(function (plugin) {
      //   if (typeof plugin.load === 'function') {
      //     plugin.load(pSrc, pVideoInfo, pParams);
      //   }
      // });

      var prerollNeedShowed = player.get('preroll') || false;
      if (prerollNeedShowed == true) {
        player.emit('ads:load');
        return;
      }

      var errorType, errorCode, errorMessage;

      //process null src error
      if (!pSrc && !pVideoInfo.src) {
        errorType = AddonError.errorTypes.INTERNAL_ERROR;
        errorCode = AddonError.errorCodes[errorType].SRC_IS_NOT_FOUND;
        errorMessage = AddonError.errorMessages[errorCode];
        new AddonError(player, errorType, errorCode, errorMessage, true);
        return;
      }

      var ext = player.utils.getExtension(pSrc || pVideoInfo.src);

      if (!player.canPlay(ext, vendorOptions)) {
        // player.utils.log("MggpPlayer.load: Vendor from " + ext + " not found!");

        errorType = AddonError.errorTypes.PLAYBACK_ERROR;
        errorCode = AddonError.errorCodes[errorType].MEDIA_FILE_IS_NOT_SUPPORTED;
        errorMessage = AddonError.errorMessages[errorCode];
        new AddonError(player, errorType, errorCode, errorMessage, true);
        return;
      }

      if (_contentVendor) {
        if (_contentVendor.constructor.mimeTypes.indexOf(ext) === -1 || _contentVendor.canPlayGroupedPrograms(ext, player.config, vendorOptions) !== Boolean(vendorOptions && vendorOptions.groupedPrograms)) {
          _contentVendor.stop();
          _contentVendor = null;
        }
      }

      if (!_contentVendor) {
        var vendor = player.getVendor(ext, vendorOptions);
        if (vendor) {
          _contentVendor = new vendor(player, player.config);
        } else {
          // player.emit('player:error', {message: 'Vendor not found from ' + ext});
          errorType = AddonError.errorTypes.PLAYBACK_ERROR;
          errorCode = AddonError.errorCodes[errorType].MEDIA_FILE_IS_NOT_SUPPORTED;
          errorMessage = AddonError.errorMessages[errorCode];
          new AddonError(player, errorType, errorCode, errorMessage, true);
          return;
        }
      }

      _contentVendor.load(player.get('src'), player.get('videoInfo'), player.get('vendorOptions'));
    }
  };

  player.showAnotherAd = function (url, adType) {
    if (!_updatePlayerTimer) {
      player.utils.log("MggpPlayer.showAnotherAd:Create timer");
      _updatePlayerTimer = setInterval(onGlobalUpdate, player.config && player.config.hasOwnProperty('timeInterval') ? player.config['timeInterval'] : 1000 / 3);
    }
    player.emit('ad:showAnotherAd', { 'url': url, 'type': adType });
  };

  player.get = function (pName) {
    if (!_data.hasOwnProperty(pName)) {
      player.utils.log('MggpPlayer:get: Property ' + pName + ' not found');
      return null;
    }

    return _data[pName].value;
  };

  player.set = function (pName, pValue, forceEmit) {
    if (!_data[pName]) {
      player.registerProperty(pName);
    }

    var valueChanged = false;

    if (_data[pName] && _data[pName].value != pValue) {
      _data[pName].value = pValue;
      valueChanged = true;
    }
    if (valueChanged || forceEmit) {
      player.emit('property:' + pName, pValue);
    }
  };

  player.registerProperty = function (pName, pDefaultValue, pNotResetable) {
    if (_data.hasOwnProperty(pName)) {
      player.utils.log('MggpPlayer:registerProperty: Property ' + pName + ' already registered');
      return;
    }
    _data[pName] = {};
    _data[pName].resetable = pNotResetable !== true;
    _data[pName].value = _data[pName]['default'] = pDefaultValue;
  };

  player.reset = function () {
    for (var name in _data) {
      if (_data[name].resetable) {
        _data[name].value = _data[name]['default'];
      }
    }
  };

  player.stop = function () {
    if (_isLoadInProgress) {
      return;
    }

    window.clearInterval(_updatePlayerTimer);
    _updatePlayerTimer = null;

    if (_contentVendor) {
      _stoppingPromise = _contentVendor.stop();
      _contentVendor = null;
    }
    player.emit('player:stop');

    player.reset();
  };

  player.dispose = function () {
    player.stop();

    _plugins.forEach(function (plugin) {
      plugin.dispose();
    });

    _observer.dispose();

    _vendors = null;
    _plugins = null;
    _observer = null;
    _contentVendor = null;
    _updatePlayerTimer = null;
    _data = null;
    _stoppingPromise = null;
  };

  /**
   * 
   * @param {string} pExtension type of the video, e.g. m3u8, mpd, mp4
   * @param {Object} pOptions additional options and info about video
   * @param {boolean} pOptions.isDrm flag that indicates if this is a drm stream
   */
  player.getVendor = function (pExtension, pOptions) {
    if (pExtension == 'mp4' && _contentVendor && player.config['maxVendorInstances'] == 1) return null;

    if (_vendors.length == 1) return _vendors[0];

    var vendor = null;

    for (var i = 0; i < _vendors.length; i++) {
      if (_vendors[i] && _vendors[i].mimeTypes.indexOf(pExtension) >= 0 && _vendors[i].canPlay(pExtension, player.config, pOptions)) {
        if (!vendor || _vendors[i]['priority'] < vendor['priority']) {
          vendor = _vendors[i];
        }
      }
    }

    return vendor;
  };

  player.getPlayableElement = function () {
    var elem = null;
    if (_contentVendor) {
      elem = _contentVendor.getPlayableElement();
    }
    return elem;
  };

  player.utils = {};
  // player.utils.getExtension = function (pUrl) {
  //     var result = "";
  //     var basename = String(pUrl).split(/[\\/]/).pop();
  //     var pos = basename.lastIndexOf(".");
  //     if (basename && pos >= 1) {
  //         var getParamsPos = basename.indexOf('?');
  //         if (getParamsPos != -1) {
  //             result = basename.slice(pos + 1, getParamsPos);
  //         } else {
  //             result = basename.slice(pos + 1);
  //         }
  //     }
  //     return result;
  // };
  player.utils.getExtension = function (pURL) {
    var result = '';
    var getPos = pURL.indexOf('?');
    if (getPos != -1) {
      pURL = pURL.slice(0, getPos);
    }
    var dotPos = pURL.lastIndexOf('.');
    if (dotPos != -1) {
      result = pURL.slice(dotPos + 1);
    }
    return result;
  };

  player.utils.merge = function (obj1, obj2) {
    obj1 = Object.create(obj1);
    for (var name in obj2) {
      if (obj2.hasOwnProperty(name)) {
        obj1[name] = obj2[name];
      }
    }
    return obj1;
  };

  player.utils.log = function (params) {
    if (player.config && player.config.hasOwnProperty('debug') && player.config['debug'] === true) {
      var date = new Date();
      console.log(date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + ":" + date.getMilliseconds() + ' -> ', params);
    }
  };

  var onGlobalUpdate = function onGlobalUpdate() {
    player.emit('player:timeUpdate');
  };

  var createVideoInstances = function createVideoInstances(pName, pContainer) {
    var video = document.createElement('video');

    pContainer ? pContainer.appendChild(video) : player.parentContainer.appendChild(video);

    try {
      video.playsInline = true;
    } catch (error) {}
    video.className = pName;
    video.style.position = 'absolute';
    player.registerProperty(pName, video, true);

    return video;
  };

  player.registerProperty('volume', 60, true);
  player.registerProperty('position', 0);
  player.registerProperty('duration', 0);
  player.registerProperty('state', -1);
  player.registerProperty('loadedFraction', 0);
  player.registerProperty('muted', false, true);

  player.registerProperty('videoInfo', {}, true);
  player.registerProperty('src', null);
  player.registerProperty('vendorOptions', {}, true);
  player.registerProperty('advertisement', false);

  player.registerProperty('quality', -1);
  player.registerProperty('qualityList', [], true);
  player.registerProperty('audioTrack', 0);
  player.registerProperty('audioTrackList', [], true);
  player.registerProperty('subtitles', "off");
  player.registerProperty('subtitlesList', [], true);

  player.on('property:state', function (pEvent) {
    if (pEvent.data == 0) {
      // Ended
      var postrollNeedShowed = player.get('postroll') || false;
      if (postrollNeedShowed == true) {

        if (_contentVendor) {
          _contentVendor.stop();
          _contentVendor = null;
        }

        player.emit('ad:playerEnded');
      } else {
        player.emit('player:completed');
      }
    }
  });

  return player;
};

var Observer = function Observer() {
  var self = this;
  self.listeners = {};

  var emittingEvents = [];
  var callbacksToAdd = {};

  this.dispose = function () {
    self.listeners = null;
  };

  function _on(eventName, callback) {
    if (!self.listeners[eventName]) {
      self.listeners[eventName] = new Set();
    }
    if (!self.listeners[eventName].has(callback)) {
      self.listeners[eventName].add(callback);
    }
  }

  this.on = function (eventName, callback) {
    if (emittingEvents.indexOf(eventName) !== -1) {
      if (!callbacksToAdd[eventName]) {
        callbacksToAdd[eventName] = new Set();
      }
      callbacksToAdd[eventName].add(callback);
    } else {
      _on(eventName, callback);
    }
  };

  this.off = function (eventName, callback) {
    if (self.listeners[eventName]) {
      self.listeners[eventName].delete(callback);
      if (self.listeners[eventName].size === 0) {
        delete self.listeners[eventName];
      }
    }
  };

  this.emit = function (eventName, pData) {
    if (!eventName) {
      return;
    }

    emittingEvents.push(eventName);

    if (self.listeners[eventName]) {
      self.listeners[eventName].forEach(function (callback) {
        callback({ name: eventName, data: pData });
      });
    }

    var namespaceGroup = eventName.slice(0, eventName.lastIndexOf(':')) + ":*";
    if (self.listeners[namespaceGroup]) {
      self.listeners[namespaceGroup].forEach(function (callback) {
        callback({ name: eventName, data: pData });
      });
    }

    var index = emittingEvents.indexOf(eventName);
    if (index !== -1) {
      emittingEvents.splice(index, 1);
    }

    if (callbacksToAdd[eventName] && emittingEvents.indexOf(eventName) === -1) {
      callbacksToAdd[eventName].forEach(function (callback) {
        _on(eventName, callback);
      });
      delete callbacksToAdd[eventName];
    }
  };

  this.isExist = function (eventName, callback) {
    var result = false;
    if (self.listeners[eventName]) {
      if (typeof callback === 'function') {
        result = self.listeners[eventName].has(callback);
      } else {
        result = self.listeners[eventName].size > 0;
      }
    }
    return result;
  };
};

/**
 * Player addon error
 * @class
 * @augments Error
 */

var AddonError = MggpPlayer.AddonError = function AddonError(pPlayer, pType, pCode, pMessage, pFatal, pNetworkStatusCode) {
  var date = new Date();
  var message = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + ":" + date.getMilliseconds() + ' -> ' + pType + '->' + pCode + '->' + pMessage;
  if (pFatal) {
    console.error(message);
  } else {
    console.warn(message);
  }

  if (!pPlayer) {
    return;
  }
  pPlayer.emit('mediaError', {
    name: this.constructor.name,
    type: pType,
    code: pCode,
    message: pMessage || 'Player Addon Error',
    fatal: pFatal || false,
    networkStatusCode: pNetworkStatusCode
  });
};
AddonError.prototype = Object.create(Error.prototype);
AddonError.prototype.constructor = AddonError;
AddonError.errorTypes = {
  NETWORK_ERROR: 'networkError',
  PLAYBACK_ERROR: 'playbackError',
  INTERNAL_ERROR: 'internalError',
  PARSING_ERROR: 'parsingError'
};
AddonError.errorCodes = {
  'networkError': {
    PLAYLIST_LOADING_ERROR: 'playlistLoadingError',
    CHUNKLIST_LOADING_ERROR: 'chunklistLoadingError',
    CHUNK_LOADING_ERROR: 'chunkLoadingError',
    KEY_LOADING_ERROR: 'keyLoadingError',
    MEDIA_FILE_LOADING_ERROR: 'mediaFileLoadingError',
    FILE_LOADING_ERROR: 'fileLoadingError'
  },
  'playbackError': {
    MEDIA_FILE_IS_NOT_SUPPORTED: 'mediaFileIsNotSupported',
    PARSING_ERROR: 'parsingError',
    DECODING_ERROR: 'decodingError',
    LEVEL_SWITCH_ERROR: 'levelSwitchError'
  },
  'internalError': {
    SRC_IS_NOT_FOUND: 'srcIsNotFound',
    CANNOT_INJECT_PLAYABLE_ELEMENT: 'cannotInjectPlayableElement',
    BUFFER_APPEND_ERROR: 'bufferAppendError'
  },
  'parsingError': {
    PARSING_ERROR: 'parsingError'
  }
};
AddonError.errorMessages = {
  'playlistLoadingError': 'Cannot load playlist from url: ',
  'chunklistLoadingError': 'Cannot load chunklist from url: ',
  'chunkLoadingError': 'Cannot load chunk from url: ',
  'mediaFileLoadingError': 'Cannot load media file from url: ',
  'fileLoadingError': 'Cannot load file from url: ',
  'mediaFileIsNotSupported': 'Unable to play file. Format is not supported. Url: ',
  'parsingError': 'Error on playlist or chunklist parsing. Url: ',
  'decodingError': 'Error on video decoding. Url: ',
  'levelSwitchError': 'Error while trying to switch level',
  'srcIsNotFound': 'Src field is undefined or it is an empty string',
  'cannotInjectPlayableElement': 'Cannot inject playable element in DOM',
  'bufferAppendError': 'Cannot append data to source buffer',
  'cannotParse': 'Cannot parse data from url:'
};

/**
 *
 * @type {MggpPlayer.Plugin}
 */
var MggpPlugin = MggpPlayer.Plugin = function (pPlayer, pConfig) {
  this.config = pConfig || {};
  this.player = pPlayer || {};
  this.container = this.player.parentContainer || document.body;
  this.namespace = 'plugin:';
};

MggpPlugin.prototype.dispose = function () {};

MggpPlugin.prototype.emit = function (pEventName, pData) {
  if (this.player.emit) {
    this.player.emit(this.namespace + pEventName, pData);
  }
};

MggpPlugin.prototype.log = function (pMessage) {
  this.player.utils ? this.player.utils.log(pMessage) : console.log(pMessage);
};

/**
 *
 * @param pPlayer
 * @param pConfig
 * @constructor
 */
var MggpVendor = MggpPlayer.Vendor = function (pPlayer, pConfig) {
  this.DEFAULT_NAMESPACE = 'player:';

  this.config = pConfig || {};
  this.player = pPlayer || {};
  this.container = this.player.parentContainer || document.body;
  this.namespace = this.DEFAULT_NAMESPACE;

  this.STREAM_ERROR = 'STREAM_ERROR';
};

MggpVendor.prototype.canPlay = function (pType) {
  return true;
};

MggpVendor.prototype.canPlayGroupedPrograms = function (pType, pConfig, pOptions) {
  return false;
};

MggpVendor.prototype.setQuality = function (pBitrate) {
  this.emit('qualityNeedChange', pBitrate);
};

MggpVendor.prototype.setAudioTrack = function (pIndex) {
  this.emit('audioTackNeedChange', pIndex);
};

MggpVendor.prototype.setSubtitles = function (pLang) {
  this.emit('subtitlesNeedChange', pLang);
};

MggpVendor.prototype.emit = function (pEventName, pData) {
  if (this.player) {
    this.player.emit(this.namespace + pEventName, pData);
  }
};

MggpVendor.prototype.set = function (pPropertyName, pValue, forceEmit) {
  if (this.player) {
    this.player.set(this.namespace != this.DEFAULT_NAMESPACE ? this.namespace + pPropertyName : pPropertyName, pValue, forceEmit);
  }
};

MggpVendor.prototype.get = function (pPropertyName) {
  return this.player && this.player.get ? this.player.get(this.namespace != this.DEFAULT_NAMESPACE ? this.namespace + pPropertyName : pPropertyName) : null;
};

MggpVendor.prototype.checkOptions = function (pOptions) {
  if (pOptions.hasOwnProperty('container')) {
    this.container = pOptions['container'];
  }

  if (pOptions.hasOwnProperty('namespace')) {
    this.namespace = pOptions['namespace'];

    if (this.player && this.namespace != this.DEFAULT_NAMESPACE) {
      this.player.registerProperty(this.namespace + 'volume', 60, true);
      this.player.registerProperty(this.namespace + 'position', 0);
      this.player.registerProperty(this.namespace + 'duration', 0);
      this.player.registerProperty(this.namespace + 'state', -1);
      this.player.registerProperty(this.namespace + 'loadedFraction', 0);
      this.player.registerProperty(this.namespace + 'muted', false, true);
    }
  }

  if (pOptions.hasOwnProperty('defaultAudioTrack')) {
    var audioTrack = parseInt(pOptions['defaultAudioTrack']);
    if (isNaN(audioTrack)) audioTrack = String(pOptions['defaultAudioTrack']);
    delete pOptions['defaultAudioTrack'];
    this.setAudioTrack(audioTrack);

    return false;
  }

  if (pOptions.hasOwnProperty('defaultQuality')) {
    var quality = parseInt(pOptions['defaultQuality']);
    delete pOptions['defaultQuality'];
    if (quality != 0) {
      this.setQuality(quality);
      return false;
    }
  }

  if (pOptions.hasOwnProperty('defaultSubtitles')) {
    this.setSubtitles(pOptions['defaultSubtitles']);
    delete pOptions['defaultSubtitles'];
  }

  return true;
};

MggpVendor.prototype.log = function (pMessage) {
  this.player && this.player.utils ? this.player.utils.log(pMessage) : console.log(pMessage);
};

MggpVendor.prototype.getPlayableElement = function () {
  return null;
};

/***/ })

/******/ });
});